export const ptBR = {
    components: {
        generic: {
            input_search_label: 'Buscar',
            title_card_label: 'Criar novo grupo',
            select_group_label: 'Selecione o Cliente',
            select_group_permission: 'Criar com base no perfil',
            profile: 'Perfil',
            input_name_group_label: 'Nome do Perfil',
            input_name_label: 'Nome',
            input_email_label: 'E-mail do usuário',
            input__current_password_label: 'Senha atual',
            input_password_label: 'Senha',
            input_confirm_password_label: 'Confirmar senha', 
            select_country_lang_label: 'Selecione o idioma',
            input_user_label:'Nome do usuário',
            input_enterprise:'Nome da empresa',
            input_host: "Host",
            input_database: "Database",
            input_schema: "Schema"

        }
    }
}